import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import Select from 'react-select'
class CarPricingAdd extends React.Component {
  state = {
    isData: false,
    id: 0,
    amount: 0,
    statesList: [],
    pickupList: [],
    state_data: null,
    pickup_data: null,
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  async componentDidMount() {
    if (this.props?.match?.params?.carId) {
      this.setState({
        car_id: this.props?.match?.params?.carId,
      })
    }
    if (this.props?.match?.params?.companyId) {
      this.setState({
        company_id: this.props?.match?.params?.companyId,
      })
    }
    await this.getStates()
    await this.getPickupList()

    const id = this.props.match.params.id
    if (id) {
      await this.getUpdateData(id)
    }
  }

  getStates = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/states`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            statesList: res.data?.data?.map((itm) => ({
              label: `${itm.name_en}/${itm.name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getPickupList = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            pickupList: res.data?.data?.map((itm) => ({
              label: `${itm.pickup_address_en}/${itm.pickup_address_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getUpdateData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/car/get-car-pricing/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          const data = res.data.data
          this.setState({
            ...data,
            state_data: this.state.statesList.find((ele) => ele.value === data.state_id),
            pickup_data: this.state.pickupList.find((ele) => ele.value === data.cruise_pickup_id),
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addItem = () => {
    let data = {
      car_id: this.state.car_id,
      state_id: this.state.state_data?.value,
      cruise_pickup_id: this.state.pickup_data?.value,
      amount: this.state.amount,
    }

    this.setState({ isData: true })
    if (this.props.id) {
      data = {
        ...data,
        id: this.props.id,
      }
      axios
        .put(Constant.getAPI() + '/car/update-car-pricing', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Price Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/car-pricing/${this.props.company_id}/${this.props.car_id}`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/car/create-car-pricing', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Price Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/car-pricing/${this.props.company_id}/${this.props.car_id}`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    if (!this.state.state_data?.value) {
      Swal.fire({
        title: 'Pickup location is required',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    } else if (!this.state.pickup_data?.value) {
      Swal.fire({
        title: 'Drop location is required',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    } else if (!this.state.amount || this.state.amount <= 0) {
      Swal.fire({
        title: 'Amount is required',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    this.addItem()
  }

  handleStateChange = (event) => {
    this.setState({ state_data: event })
  }

  handlePickupChange = (event) => {
    this.setState({ pickup_data: event })
  }

  handleClear = () => {
    this.setState({ pickup_data: null })
  }

  handleStateClear = () => {
    this.setState({ state_data: null })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Select Pickup Location</label>
                <div className="col-sm-8">
                  <Select
                    name="state_data"
                    value={this.state.state_data}
                    onChange={this.handleStateChange}
                    options={this.state.statesList}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleStateClear}
                    placeholder="Select Options"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Select Drop Location</label>
                <div className="col-sm-8">
                  <Select
                    name="pickup_data"
                    value={this.state.pickup_data}
                    onChange={this.handlePickupChange}
                    options={this.state.pickupList}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleClear}
                    placeholder="Select Options"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Amount</label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    placeholder="Amount"
                    onChange={this.handleChange}
                    value={this.state.amount}
                    min={0}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/car-pricing/${this.props.company_id}/${this.props.car_id}`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(CarPricingAdd)
